module.exports = __webpack_public_path__ + "img/furniture-1-6.b7bb3dbd.jpg";